module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_hwaqfw.b59936e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_hwaqfw.png
// module id = wn/4
// module chunks = 21